import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import HttpClient from '../../utils/HttpClient';
import { confirmAlert } from 'react-confirm-alert';

const PostCommentsEdit = ({ comment, postId, onUpdate }) => {
    const dispatch = useDispatch()
    const { UserProfileID } = useSelector((state) => state.app);
    const [commentText, setCommentText] = useState("")
    const [commentToEdit, setCommentToEdit] = useState(false)

    useEffect(() => {
        setCommentText(comment?.comment || "");
    }, [comment])

    const handleCommentUpdate = async (e) => {
        e.preventDefault()
        if (commentText.trim() === "") {
            return toast.error("Your comment should not be empty!")
        }
        const data = {
            postId: postId,
            comment: commentText
        }
        const response = await HttpClient.requestData(`business-post-comment/${comment?._id}`, "PUT", data);
        if (response && response.status) {
            setCommentToEdit(false);
            onUpdate();
        }
    }

    const handleCommentEdit = (event, comment) => {
        setCommentToEdit(true);
    }

    const handleCommentRemove = async (event, comment) => {
        event.preventDefault();
        confirmAlert({
            title: (
                <h4>Confirm delete</h4>
            ),
            message: (
                <p>Are you sure you want to delete this comment? </p>
            ),
            buttons: [
                {
                    label: "Yes",
                    onClick: () => removeComment(comment?._id),
                    className: 'btn btn-primary',
                },
                {
                    label: "No",
                    className: 'btn btn-secondary',
                },
            ],
        });
    }

    const removeComment = async (id) => {
        const response = await HttpClient.requestData(`business-post-comment/${comment?._id}`, "DELETE");
        if (response && response?.status) {
            onUpdate();
            toast.success("Comment deleted successfully!");
        }
    }

    return (
        <div className='ownpostcommentdiv'>
            {commentToEdit ? (
                <div className='ownpostcommentdivmain'>
                    {/* <div className="cntnctimgdivnamin">
                        <img src={UserProfileID?.profilePhoto || cntnctimg3} alt={UserProfileID?.personName || "..."} title={UserProfileID?.personName || "..."} />
                    </div> */}

                    <div style={{
                        height: 'auto'
                    }} className='textareadibmainmainbrdr'
                    >
                        <div className='textareadibmain'>
                            <textarea className='textareadibmainrerare'
                                placeholder='Write a comment...'
                                onChange={(e) => setCommentText(e.target.value)}
                                value={commentText || ""}
                                readOnly={false}
                            />
                        </div>
                        {
                            commentText?.trim() && (
                                <>
                                    <div className="mesagsendidvmain"
                                        style={{
                                            marginTop: "-10px",
                                        }}
                                        onClick={(e) => handleCommentUpdate(e)}>
                                        <i className="fa-solid fa-paper-plane" style={{ cursor: "pointer" }}></i>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            ) : (
                <p>{commentText}</p>
            )}

            <div className='cmnt-action-icons'>
                {!commentToEdit && (
                    <span className='' style={{ cursor: "pointer", marginRight: "5px" }} onClick={(e) => handleCommentEdit(e, comment)}>
                        <i className="fa-solid fa-edit" title='Update comment'></i>
                    </span>
                )}
                <span className='' style={{ cursor: "pointer" }} onClick={(e) => handleCommentRemove(e, comment)}>
                    <i className="fa-solid fa-trash" title='Remove comment'></i>
                </span>
            </div>
        </div>
    )
}

export default PostCommentsEdit
